import React from 'react'
import { AutoComplete } from '../../../../itrust_common/components/others'
import { connect, useDispatch } from 'react-redux'
import * as $ from 'jquery';
import { contactLoad } from '../../../../redux/actions/addOns/contactListsAction';
import { patientMessagesLoad } from '../../../../redux/actions/patient/patientMessageActions';
import { quickActions, quickActionsReset } from '../../../../redux/actions/dashboard/quickActionActions';
import { callPopUpEdit, voipEdit } from '../../../../redux/actions/addOns/voip/voipActions';
import PatientInfo from '../../../../components/authorised/appointment/PatientInfo';
import { patientLoad } from '../../../../redux/actions/patient/patientActions';
import { CreateExamButton, CreateOrderButton } from '../../../../components/authorised/buttons';
import { API_VERSION_ONE, handleAPI } from '../../../../itrust_common/utils/apiUtils';
import { patientWhatsAppLogsLoad, whatsAppAccountLoad, whatsAppEdit, whatsAppPatientLoad, whatsAppProfileLoad } from '../../../../redux/actions/addOns/whatsApp/whatsAppActions';
import { reportEdit } from '../../../../redux/actions/reports/reportsActions';

function SelectPatientModal(props) {
  const { quickAction, patient, callPopUpStatus, organisationId, storeWhatsAppNumber, storeSpecificPatients, currentStoreId } = props
  const dispatch = useDispatch()

  const handlePatientSelect = async (id) => {
    let patient = await handleOnPatientSelect(id)
    dispatch(quickActions({ selected_patient_id: id, patient: patient }))
  }

  const handleOnPatientSelect = async (id) => {
    const URL = `/${API_VERSION_ONE}/patients/${id}`;
    let res = await handleAPI(URL, { include: '*' }, 'GET')
    return res.data.patient
  }

  const handleCallMessagePatientLoad = async (patientId, editType) => {
    if (editType === 'patient_message') {
      let filter = { sort: "send_at", direction: 'asc', rpp: 999999999, include: ['patient', 'store', 'staff', 'message_template'] }
      await dispatch(contactLoad(patientId, { include: '*' }))
      await dispatch(patientMessagesLoad({ ...filter, patient_id: patientId }))
      dispatch(callPopUpEdit(editType))
      dispatch(voipEdit({ prevTab: 'patients' }))
    }
    else {
      await dispatch(contactLoad(patientId, { include: '*' }))
      dispatch(callPopUpEdit(editType))
      dispatch(voipEdit({ prevTab: 'patients' }))
    }
  }

  const handleSelectPatientCancel = () => {
    $('#patientSelect-modal').modal('hide');
    dispatch(quickActionsReset())
  }

  const handleCreatePrescription = (patientId) => {
    dispatch(reportEdit({ patient_id: patientId }))
    setTimeout(() => $('#selectPrescriptionProvider-modal').modal('show'), 700);
  }

  const handleWhatsApp = async (patientId) => {
    callPopUpStatus && dispatch(callPopUpEdit(false))
    await dispatch(whatsAppPatientLoad(patientId))
    let whatsAppFilter = { sort: 'created_at', rpp: 99999999999999, page: 1, filter: {}, search: '', direction: 'asc', patient_id: patientId }
    await dispatch(patientWhatsAppLogsLoad(whatsAppFilter))
    if (!storeWhatsAppNumber) {
      await dispatch(whatsAppProfileLoad({ store_id: localStorage.getItem('StoreID'), category: "whatsapp", include: '*' }))
      await dispatch(whatsAppAccountLoad({ organisation_id: organisationId }))
    }
    dispatch(whatsAppEdit({ patientProfile: true }))
  }

  const handleAfterSelectFlow = async () => {
    if (quickAction.select_patient_modal == 'sms') {
      await handleCallMessagePatientLoad(patient.id, 'patient_message')
    }
    else if (quickAction.select_patient_modal == 'make_call') {
      await handleCallMessagePatientLoad(patient.id, 'patient')
    }
    else if (quickAction.select_patient_modal == 'prescription') {
      await handleCreatePrescription(patient.id, 'prescription')
    }
    else if (quickAction.select_patient_modal == 'whatsapp') {
      await handleWhatsApp(patient.id, 'whatsapp')
    }
    $('#patientSelect-modal').modal('hide');
  }

  const getNextStepLabel = () => {
    switch (quickAction.select_patient_modal) {
      case 'sms':
        return 'Send Text Message'
      case 'make_call':
        return 'Make Phone Call'
      case 'whatsapp':
        return 'Send WhatsApp Message'
      case 'prescription':
        return 'Create Prescription'
      default:
        return 'Next'
    }
  }

  const handleFullMode = () => {
    // $('#patientSelect-modal').modal('hide')
    setTimeout(() => $('#fullModePatient-modal').modal({ backdrop: 'static', keyboard: false }), 300);
    dispatch(patientLoad(patient.id, { include: ['address', 'social_histories', 'medical_histories', 'review_of_systems', 'documents'] }))
  }

  const RenderPatientAction = () => {
    if (['patient', 'exam', 'order'].includes(quickAction.select_patient_modal)) {
      return (
        <button className="btn btn-primary" type="button" onClick={handleFullMode}>Full Mode</button>
      )
    }
    return null
  }

  return (
    <>
      <div className="modal fade popper overflow-auto" id={`patientSelect-modal`} tabIndex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
        <div className={`modal-dialog`} role="document">
          <div className={`modal-content`}>
            <div className="modal-header align-items-center border-0">
              <h5 className="text-dark">Search and Select Patient</h5>
              <div className="d-flex flex-row">
                <button type="button" className="btn btn-outline-primary" onClick={handleSelectPatientCancel}>Cancel</button>
              </div>
            </div>
            <div className='p-5'>
              <AutoComplete fieldName="patient" placeholder="Search patient by Name" key={patient.id} textField="name" valueField="id" onSelect={(id) => handlePatientSelect(id)} klass="Patient" wrapperClasses="w-100 position-relative mb-6" additionalFilters={{ store_id: (storeSpecificPatients && currentStoreId) ? currentStoreId : '' }} />
              {patient.id && <>
                <PatientInfo patient={patient} RenderPatientAction={RenderPatientAction} />
                <div className='d-flex justify-content-end py-4'>
                  {(quickAction.select_patient_modal == 'exam' || quickAction.select_patient_modal == 'order') ? <>
                    {quickAction.select_patient_modal == 'exam' && <CreateExamButton patientId={patient.id} isQuickAction={true}>
                      <button type="button" className="btn btn-primary">Create Exam</button>
                    </CreateExamButton>}
                    {quickAction.select_patient_modal == 'order' && <CreateOrderButton isQuickAction={true} patientId={patient.id} patientName={patient.name}>
                      <button type="button" className="btn btn-primary">Create Order</button>
                    </CreateOrderButton>}
                  </> :
                    <button className='btn btn-primary' onClick={handleAfterSelectFlow}>{getNextStepLabel()}</button>
                  }
                </div>
              </>}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  const { dashboard: { quickAction }, voip, organisation: { organisation }, whatsApp, currentStore } = state
  return {
    quickAction,
    patient: quickAction.patient,
    callPopUpStatus: voip?.call_pop_up_status,
    organisationId: organisation.id,
    storeWhatsAppNumber: whatsApp.profile_info?.phone_number,
    storeSpecificPatients: organisation.preferences?.store_specific_patients,
    currentStoreId: currentStore.store.id,
  }
}

export default connect(mapStateToProps)(SelectPatientModal)